import type { IconSvgObject } from './types';

const BookmarkPlusIcon: IconSvgObject = [
  ["path", { d: "M5 4.5V20.7454C5 21.1622 5.33785 21.5 5.75461 21.5C5.91409 21.5 6.06948 21.4495 6.19845 21.3557L11.0956 17.7941C11.3584 17.603 11.675 17.5 12 17.5C12.325 17.5 12.6416 17.603 12.9044 17.7941L17.8015 21.3557C17.9305 21.4495 18.0859 21.5 18.2454 21.5C18.6621 21.5 19 21.1622 19 20.7454V4.5C19 3.39543 18.1046 2.5 17 2.5H7C5.89543 2.5 5 3.39543 5 4.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0009 6.5V12.5M15.0059 9.495L9.00586 9.495", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookmarkPlusIcon;
